var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentLarge = function SvgDocumentLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23.303,
    height: 28.368,
    viewBox: "0 0 23.303 28.368",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", {
    id: "Group_10749",
    "data-name": "Group 10749",
    transform: "translate(0 0)"
  }, React.createElement("g", {
    id: "Group_10741",
    "data-name": "Group 10741"
  }, React.createElement("path", {
    id: "Path_28070",
    "data-name": "Path 28070",
    d: "M21.037,25.993H4.267A1.892,1.892,0,0,1,2.375,24.1V2.266A1.892,1.892,0,0,1,4.267.375h16.77a1.892,1.892,0,0,1,1.892,1.891V24.1a1.892,1.892,0,0,1-1.892,1.892",
    fill: "#d6cece"
  }), React.createElement("path", {
    id: "Rectangle_3470",
    "data-name": "Rectangle 3470",
    d: "M1.892,0h16.77a1.892,1.892,0,0,1,1.892,1.892V23.727a1.891,1.891,0,0,1-1.891,1.891H1.892A1.892,1.892,0,0,1,0,23.726V1.892A1.892,1.892,0,0,1,1.892,0Z",
    transform: "translate(2.375 0.375)",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.75
  }), React.createElement("path", {
    id: "Path_28071",
    "data-name": "Path 28071",
    d: "M19.037,27.993H2.267A1.892,1.892,0,0,1,.375,26.1V4.266A1.892,1.892,0,0,1,2.267,2.375h16.77a1.892,1.892,0,0,1,1.892,1.891V26.1a1.892,1.892,0,0,1-1.892,1.892",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Rectangle_3471",
    "data-name": "Rectangle 3471",
    d: "M1.892,0h16.77a1.892,1.892,0,0,1,1.892,1.892V23.727a1.891,1.891,0,0,1-1.891,1.891H1.892A1.892,1.892,0,0,1,0,23.726V1.892A1.892,1.892,0,0,1,1.892,0Z",
    transform: "translate(0.375 2.375)",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_388",
    "data-name": "Line 388",
    x2: 12.383,
    transform: "translate(4.46 22.509)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_389",
    "data-name": "Line 389",
    x2: 12.383,
    transform: "translate(4.46 22.509)",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_390",
    "data-name": "Line 390",
    x2: 12.383,
    transform: "translate(4.46 12.509)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_391",
    "data-name": "Line 391",
    x2: 12.383,
    transform: "translate(4.46 12.509)",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_392",
    "data-name": "Line 392",
    x2: 12.383,
    transform: "translate(4.46 17.509)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_393",
    "data-name": "Line 393",
    x2: 12.383,
    transform: "translate(4.46 17.509)",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.75
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumentLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documentLarge.2838489d.svg";
export { ForwardRef as ReactComponent };